module.exports = __webpack_public_path__ + "img/other-docs-web.4f945678.svg";